module.exports = __webpack_public_path__ + "img/40_69_005_050.10c74fd7.jpg";